import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './Tree.module.scss';

import Spinner from 'Flow2/components/UI/Spinner/Spinner';
import FlexRow from 'Flow2/components/UI/Container/FlexRow'
import FlexCol from 'Flow2/components/UI/Container/FlexColumn'

import { injectIntl } from 'react-intl';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faInfoCircle, faPlusSquare, faMinusSquare, faFolderOpen, faFolder, faCaretRight, faCaretDown, faList } from '@fortawesome/free-solid-svg-icons';

import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

const onDragEnter = (e) => {
    e.preventDefault();
    e.target.classList.add(classes.dragover);
}

const onDragLeave = (e) => {
    e.preventDefault();
    e.target.classList.remove(classes.dragover);
}

const onDragEnd = (e) => {
    e.preventDefault();
    e.target.classList.remove(classes.dragover);
}

export const onDragOver = (e) => {
    e.preventDefault();
}

const onDrop = (e, refId, callback) => {
    e.preventDefault();
    e.target.classList.remove(classes.dragover);
    
    const id = e.dataTransfer.getData("text/plain");
    
    if(id && refId && id+"" !== refId+"") {
        console.log(id, refId);
        callback(id, refId);
        //this.onAdd(id);
    }
}

const onDragStart = (event, id) => {
		event.dataTransfer.dropEffect = "move";
		event.dataTransfer.setData("text/plain", id);
	}

const hasChilds = (data, selector) => {
    return data[selector] && data[selector].length;
}

const getChilds = (data, selector) => {
    return hasChilds(data, selector) ? data[selector] : [];
}

const TreeContentHeader = (props) => {
    let cls = classes;
    
    const controls = [];
    if(props.controls && props.onAdd) {
        controls.push(
            <div className={[cls.Control].join(' ')}><FontAwesomeIcon icon={faPlusSquare} /></div>
        );
    }
    if(props.controls && props.onRemove) {
        controls.push(
            <div className={[cls.Control].join(' ')}><FontAwesomeIcon icon={faMinusSquare} /></div>
        );
    }
    if(props.controls && props.onSearchLinked) {
        controls.push(
            <div className={[cls.Control].join(' ')}><FontAwesomeIcon icon={faList} /></div>
        );
    }
    controls.push(
        <div className={[cls.Control].join(' ')}><FontAwesomeIcon icon={faInfoCircle} /></div>
    );
    
    return (
        <FlexRow className={[cls.TreeContentHeader].join(' ')} >
            <div className={[cls.Collapse].join(' ')} />
            <div className={[cls.Name, "flexGrow"].join(' ')}>Name</div>
            <div className={[cls.Level].join(' ')}>Berechtigung</div>
            <div className={[cls.Usecount].join(' ')}>Verwendung</div>
            <FlexRow className={[cls.Controls].join(' ')}>{ controls }</FlexRow>
        </FlexRow>
    );
}

const Child = (props) => {
    let childArray = getChilds(props.data, 'children');
	
    let childs = [];
    if(childArray.length && !props.collapsed[props.data.id]) {
        childs = childArray.map((data) => {
            return (
                <Child
                    key={data.id}
                    registerCollapsed={props.registerCollapsed}
                    toggleCollapsed={props.toggleCollapsed}
                    collapsed={props.collapsed}
                    onAdd={props.onAdd}
                    onRemove={props.onRemove}
                    onSearchLinked={props.onSearchLinked}
                    onClick={props.onClick}
                    isSelected={props.isSelected}
                    controls={props.controls}
                    callback={props.callback}
                    data={data} />
            );
        });
    }
    
    let cls = classes;
    
    let selected = "";
    if(props.isSelected) {
        selected = props.isSelected(props.data);
    }
    
    let add = "";
    if(props.controls && props.onAdd) {
        add = (
            <div className={[cls.Control, cls.Add, selected].join(' ')} onClick={() => props.onAdd(props.data)}>
                <FontAwesomeIcon icon={faPlusSquare} />
            </div>
        );
    }
    
    let remove = "";
    if(props.controls && props.onRemove) {
        remove = (
            <div className={[cls.Control, cls.Remove, selected].join(' ')} onClick={() => props.onRemove(props.data)}>
                <FontAwesomeIcon icon={faMinusSquare} />
            </div>
        );
    }
    
    let linked = "";
    if(props.controls && props.onSearchLinked) {
        linked = (
            <div className={[cls.Control, cls.Add, selected].join(' ')} onClick={() => props.onSearchLinked(props.data.id)}>
                <FontAwesomeIcon icon={faList} />
            </div>
        );
    }
    
    //console.log(props.data);
    
    let short = "";
    if(props.data.desc) {
        short = (
            <div className={[cls.Control, cls.Info].join(' ')} title={props.data.desc}>
                <FontAwesomeIcon icon={faInfoCircle} />
            </div>
        );
    }
    
    return (
        <>
        <div className={cls.ChildContainer}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDragEnd={onDragEnd}
            onDragOver={onDragOver}
            onDragStart={(e) => onDragStart(e, props.data.id)}
            onDrop={(e) => onDrop(e, props.data.id, props.callback)}
            draggable={props.callback ? true : false/*this.state.edit*/}>
            
            <FlexRow className={[cls.ChildHeader, selected].join(' ')} >
                <Collapse
                    data={props.data}
                    hasChilds={childArray.length ? true : false}
                    toggleCollapsed={props.toggleCollapsed}
                    collapsed={props.collapsed}
                    cls={cls}/>
                <div className={[cls.Click, "flexGrow", "pointer"].join(' ')} onClick={() => props.onClick(props.data)}>{ props.data.name }</div>
                
                <div className={[cls.Level, "pointer"].join(' ')} onClick={() => props.onClick(props.data)}>{parseInt(props.data.level) ? "Level"+props.data.level : "-"}</div>
                <div className={[cls.Usecount, "pointer"].join(' ')} onClick={() => props.onClick(props.data)}>{props.data.usecount}</div>
                <FlexRow className={[cls.Controls].join(' ')}>
                    { short }
                    { linked }
                    { add }
                    { remove }
                </FlexRow>
            </FlexRow>
        </div>
        <FlexCol className={[cls.Childs, childs.length ? cls.hasChilds : cls.noChilds].join(' ')}>
                { !props.collapsed[props.data.id] ? childs : "" }
            </FlexCol>
            </>
    );
}

class Tree extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            open: true,
            collapsed: props.collapsed,
            collapsedAll: true,
			filter: null,
			tree: []
        }
    }
    
    toggle = () => {
        this.setState({
            open: !this.state.open
        });
    }
    
    registerCollapsed = (id) => {
        let collapsed = { ...this.state.collapsed };
        collapsed[id] = true;
        this.setState({
            collapsed: collapsed
        });
    }
    
    toggleCollapsed = (id) => {
        let collapsed = { ...this.state.collapsed };
        collapsed[id] = !collapsed[id];
        this.setState({
            collapsed: collapsed
        });
    }

    toggleCollapseAll = (collapse) => {
        let collapsed = { ...this.state.collapsed };
        for(let key in collapsed) {
            collapsed[key] = collapse;
        }
        this.setState({
            collapsed: collapsed
        });
    }
	
	onClick = (data) => {
		
	}
    
    onAdd = (data) => {
        
    }
    
    onRemove = (data) => {
        
    }
	
	isSelected = (data) => {
        
    }
	
	filterTree = (data, filter) => {
		if(filter && filter.search && filter.field) {
			return this.walkThrough(data, filter);
		}
		if(DataUtil.isPorscheArchiv()) {
            return this.permissionsCheck(data);
        }
		return [ ...data ] || [];
	}
	
	walkThrough = (data, filter) => {
		let tree = []
		for(let i = 0; i < data.length; i++) {
			let elm = { ...data[i] };
            //console.log(elm);
			let childs = this.walkThrough(getChilds(elm, 'children'), filter);
			elm['children'] = childs;
			
			if(childs.length) {
				tree.push(elm);
			} else if(elm[filter.field] && elm[filter.field].toLowerCase().indexOf(filter.search.toLowerCase()) !== -1) {
				tree.push(elm);
			}
		}
		
		return tree;
	}
	
	permissionsCheck = (data) => {
		let tree = []
		let user = this.props.user.role;
        user = parseInt(user.replace("level", ""));
        //console.log(user);
		for(let i = 0; i < data.length; i++) {
			let elm = data[i];
            //console.log(parseInt(elm.level), user, parseInt(elm.level) <= user);
            if(!elm.level || parseInt(elm.level) <= user) {
                let childs = this.permissionsCheck(getChilds(elm, 'children'));
                elm['children'] = childs;
				tree.push(elm);
            } 
            //console.log(elm);
			
		}
		
		return tree;
	}
   
    render() {
        //console.log(this.props);
        let tree = this.filterTree(this.props.data, /*{search: "3", field: "level"}*/ this.props.filter).map((data) => {
            return (
                <Child
                    key={data.id}
                    registerCollapsed={this.registerCollapsed}
                    toggleCollapsed={this.toggleCollapsed}
                    collapsed={this.state.collapsed}
                    onAdd={this.props.onAdd || this.onAdd}
                    onRemove={this.props.onRemove || this.onRemove}
                    onSearchLinked={this.props.onSearchLinked || false}
					onClick={this.props.onClick || this.onClick}
                    isSelected={this.props.isSelected || this.isSelected}
                    controls={this.props.controls || false}
                    callback={this.props.callback || false}
                    data={data} />
            );
        });

        let cls = classes;

        return (
            <div className={[cls.TreeContainer].join(' ')}
                onDragEnter={onDragEnter}
                onDragLeave={onDragLeave}
                onDragEnd={onDragEnd}
                onDragOver={onDragOver}
                //onDragStart={(e) => onDragStart(e, props.data.id)}
                onDrop={(e) => onDrop(e, -1, this.props.callback)}
                >
                <FlexRow className={[cls.TreeHeader].join(' ')}>
                    <div className={["flexGrow"].join(' ')}>{this.props.title}</div>
                        {this.props.extraContent}
						{this.props.controls}
                    <div className={[cls.Control].join(' ')} onClick={() => this.toggleCollapseAll(true)}>
                        <FontAwesomeIcon icon={faFolder} />
                    </div>
                    <div className={[cls.Control].join(' ')} onClick={() => this.toggleCollapseAll(false)}>
                        <FontAwesomeIcon icon={faFolderOpen} />
                    </div>
                    <div className={[cls.Control].join(' ')} onClick={this.toggle}>
                        <FontAwesomeIcon icon={this.state.open ? "chevron-up" : "chevron-down"} />
                    </div>
                </FlexRow>
                
                <TreeContent
                    { ...this.props }
                    tree={tree}
                    open={this.state.open}
                    loading={this.props.loading}
                    cls={cls} />
            </div>
        );
        
    }
};

const TreeContent = (props) => {
    if(!props.open) return "";
    if(props.loading) return (<Spinner />);
    
    return (
        <>
        <TreeContentHeader {...props}/>
        <FlexCol className={props.cls.TreeContent}>
            { props.tree }
        </FlexCol>
        </>
    );
}

const Collapse = (props) => {
    if(!props.hasChilds) {
        return <><div className={[props.cls.Collapse].join(' ')} /></>
    }
    
    let icon = props.collapsed[props.data.id] ? faCaretRight : faCaretDown;
    
    return (
        <div className={[props.cls.Control, props.cls.Collapse].join(' ')} onClick={() =>  props.toggleCollapsed(props.data.id)}>
            <FontAwesomeIcon icon={icon} />
        </div>
    );
}

const mapStateToProps = (state, ownProps) => {
    
    // create collapsed structure to start with tree all collapsed
    const collapsed = {};
    if(ownProps.list) {
        Object.values(ownProps.list).forEach(item => {
            if(item.children.length) {
                collapsed[item.id] = true;
            }
        })
    }
    
    return {
        user: state.auth.user,
        collapsed: collapsed
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Tree));
